// extracted by mini-css-extract-plugin
module.exports = {"root":"DrawerPwa_root__3-w1s","closeButton":"DrawerPwa_closeButton__3JibU","content":"DrawerPwa_content__29f16"};